Object.defineProperty(exports, "__esModule", { value: true });
exports.compileAllFields = exports.compileFieldConfig = void 0;
const graphql_1 = require("graphql");
const Field_1 = require("../Field");
const resolver_1 = require("./resolver");
const services_1 = require("./services");
const fieldType_1 = require("./fieldType");
const ArgDecorators_1 = require("../../arg/ArgDecorators");
function compileFieldConfig(target, fieldName) {
    const fieldRegistryConfig = Field_1.fieldsRegistry.get(target, fieldName);
    const { type, description, isNullable, itemNullable, castTo, itemCast, onlyDecoratedArgs, deprecationReason } = fieldRegistryConfig;
    const args = ArgDecorators_1.compileFieldArgs(target, fieldName, onlyDecoratedArgs);
    const arrayFieldType = fieldRegistryConfig.itemType || fieldRegistryConfig.itemCast;
    const explicitType = arrayFieldType ? arrayFieldType : castTo ? castTo : type;
    const resolvedType = services_1.resolveRegisteredOrInferredType(target, fieldName, explicitType);
    // if was not able to resolve type, try to show some helpful information about it
    if (!resolvedType && !fieldType_1.validateNotInferableField(target, fieldName)) {
        return;
    }
    // show error about being not able to resolve field type
    if (!services_1.validateResolvedType(target, fieldName, resolvedType)) {
        fieldType_1.validateNotInferableField(target, fieldName);
        return;
    }
    const finalType = arrayFieldType
        ? new graphql_1.GraphQLNonNull(new graphql_1.GraphQLList(services_1.enhanceType(resolvedType, itemNullable)))
        : services_1.enhanceType(resolvedType, isNullable);
    return {
        description,
        type: finalType,
        deprecationReason,
        resolve: resolver_1.compileFieldResolver(target, fieldName, castTo || itemCast),
        args
    };
}
exports.compileFieldConfig = compileFieldConfig;
function getAllFields(target) {
    const fields = Field_1.fieldsRegistry.getAll(target);
    const finalFieldsMap = {};
    Object.keys(fields).forEach((fieldName) => {
        if (services_1.isRootFieldOnNonRootBase(target, fieldName)) {
            throw new Field_1.FieldError(target, fieldName, `Given field is root field (@Query or @Mutation) not registered inside @SchemaRoot type. `);
        }
        const config = Field_1.fieldsRegistry.get(target, fieldName);
        finalFieldsMap[config.name] = compileFieldConfig(target, fieldName);
    });
    return finalFieldsMap;
}
function compileAllFields(targetWithParents) {
    const finalFieldsMap = {};
    targetWithParents.forEach((targetLevel) => {
        Object.assign(finalFieldsMap, getAllFields(targetLevel));
    });
    return finalFieldsMap;
}
exports.compileAllFields = compileAllFields;
//# sourceMappingURL=fieldCompiler.js.map